// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4f-6";
export var headerCell = "_4f-2";
export var rowWrapper = "_4f-4";
export var stickyAggregationCell = "_4f-a";
export var stickyAggregationRow = "_4f-7";
export var stickyColumnCell = "_4f-9";
export var stickyColumnHeaderCell = "_4f-8";
export var table = "_4f-1";
export var virtualRowWrapper = "_4f-5";
export var virtualTableContainer = "_4f-0";
export var white = "_4f-3";